import { createSlice } from "@reduxjs/toolkit";

const threadsSlice = createSlice({
  name: "threads",
  initialState: {
    threads: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchThreadsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchThreadsSuccess: (state, action) => {
      state.loading = false;
      state.threads = action.payload;
      state.error = null;
    },
    fetchThreadsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createThreadRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createThreadSuccess: (state, action) => {
      state.loading = false;
      // Insert new thread at the beginning (most recent first)
      state.threads.unshift(action.payload);
      state.error = null;
    },
    createThreadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteThreadRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteThreadSuccess: (state, action) => {
      state.loading = false;
      state.threads = state.threads.filter(
        (thread) => thread.id !== action.payload
      );
      state.error = null;
    },
    deleteThreadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchThreadsRequest,
  fetchThreadsSuccess,
  fetchThreadsFailure,
  createThreadRequest,
  createThreadSuccess,
  createThreadFailure,
  deleteThreadRequest,
  deleteThreadSuccess,
  deleteThreadFailure,
} = threadsSlice.actions;

export default threadsSlice.reducer;

